import {SearchIcon} from '@primer/octicons-react'
import {TextInput} from '@primer/react'
import {useId} from 'react'

import styles from './CustomizeSearch.module.css'

export interface CustomizeSearchProps {
  value: string
  onChange: (value: string) => void
  /** Accessible label, so each tab describes the list it filters. */
  label: string
  placeholder?: string
}

/** Filter input for a Customize tab. */
export function CustomizeSearch({value, onChange, label, placeholder = 'Search customizations'}: CustomizeSearchProps) {
  const id = useId()

  return (
    <>
      <label className="sr-only" htmlFor={id}>
        {label}
      </label>
      <TextInput
        id={id}
        block
        className={styles.search}
        type="search"
        value={value}
        onChange={event => onChange(event.target.value)}
        leadingVisual={SearchIcon}
        placeholder={placeholder}
      />
    </>
  )
}
